import React from "react";
import { Link } from "react-router-dom";
import { api } from "../../api";
import toast from "react-hot-toast";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

function successfulReg() {
  const user = JSON.parse(sessionStorage.getItem("user"));

  const handleResendMail = async () => {
    let payload = {
      email: user.email,
    };

    try {
      const res = await api.resendMail(payload);
      toast.success(res.message);
    } catch (error) {
      toast.remove();
      toast.error(error.response.data.error[0]);
    }
  };
  return (
    <div className="fixed top-0 left-0 w-screen h-screen grid place-items-center bg-black bg-opacity-50 p-10 z-50">
      <div className="">
        <div className="min-h-[12rem] md:w-[600px] 2xl:w-11/12 2xl:min-h-[40rem] bg-white rounded-2xl flex flex-col justify-center p-6 2xl:p-10 relative">
          <h1 className="text-2xl xl:text-3xl 2xl:text-6xl leading-6 font-medium text-primary mb-4 2xl:mb-10 text-center">
            Your account has been created successfully! 🔥
          </h1>
          <div className="mb-6">
            {/* <h1 className="text-center font-medium text-darkBlue text-xl mb-2">Check your mail</h1> */}
            <p className="py-2 text-black font-normal  text-lg xl:text-xl 2xl:text-4xl 2xl:font-medium 2xl:text-center">
              A mail has been sent to{" "}
              <span className="font-medium 2xl:font-semibold 2xl:text-5xl">
                {user.email}
              </span>{" "}
              with your password and a verification link.
            </p>
            <p className="py-2 2xl:my-6 text-black font-normal text-lg xl:text-xl 2xl:text-4xl 2xl:font-medium">
              Click on the button in the mail to verify your email address, if
              it's not in your inbox, it might be in your spam or junk folder{" "}
            </p>
          </div>
          <div className="text-center">
            <p className="text-lg xl:text-xl 2xl:text-4xl">
              Can't find the email?&nbsp;
              <button
                onClick={handleResendMail}
                className="font-medium text-primary xl:text-xl 2xl:text-4xl"
              >
                Resend Email
              </button>
            </p>
          </div>

          <div className="flex justify-end">
            <Link
              to="/candidate/profile"
              className="font-normal text-primary underline xl:text-xl 2xl:text-4xl 2xl:font-medium"
            >
              Proceed
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default successfulReg;
